export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11410.685e77e6.jpg";